// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth-form-secondary-link[data-v-2e3ef27e]{border-top:1px solid #d2dce3;margin-top:2rem;padding-top:1.25rem;text-align:center}.auth-form-secondary-link__prompt[data-v-2e3ef27e]{font-size:.875rem;font-weight:700;margin-bottom:.625rem}.auth-form-secondary-link__link[data-v-2e3ef27e]{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
